export class DocFormValidationError extends Error {
    constructor(message) {
        super(message);
    }
}
